import TooltipSystemV2 from './TooltipSystemV2';
import './TooltipSystemV2.scss';

export default TooltipSystemV2;
